import React, { FC, ReactElement, MouseEvent } from 'react';
import styled from 'styled-components';
import Svg from '../../../Generic/Icons';
import { StyledRotatedSpinner } from '../../../ListingPage/Loader/Spinner';

const StyledIconWrapper = styled.span`
    display: block;
    position: absolute;
    width: 24px;
    height: 24px;
    top: 8px;
    left: 8px;
`;

const StyledButton = styled.button`
    position: relative;
    border-radius: 3px;
    color: ${({ theme }) => theme.colors.colorFacebookV2};
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
    width: 100%;
    padding-left: 32px;
    border: 1px solid ${({ theme }) => theme.colors.charcoal40};
    height: 40px;
    margin: 0 auto 18px;
    max-width: 300px;
`;

export const StyledPlaceholder = styled(StyledRotatedSpinner)`
    height: 40px;
    width: 40px;
    margin: 0 auto 13px;
`;

export interface ForgotPasswordLinkProps {
    handleFacebookAuthClick: (event: MouseEvent<HTMLButtonElement>) => void;
    isLoaded: boolean;
}

const FacebookButton: FC<ForgotPasswordLinkProps> = ({ handleFacebookAuthClick, isLoaded, children }): ReactElement =>
    isLoaded ? (
        <StyledButton data-testid="fb_btn" type="button" onClick={handleFacebookAuthClick}>
            <StyledIconWrapper>
                <Svg type="facebook2" />
            </StyledIconWrapper>
            {children}
        </StyledButton>
    ) : (
        <StyledPlaceholder />
    );

export default FacebookButton;
